module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select_distributor":"Выберите дистрибьютора"},"en":{"select_distributor":"Select distributor"}}')
  delete Component.options._Ctor
}
